import Avatar from 'common/Avatar/Avatar'
import Styles from './AccountToggle.module.scss'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { getInitials } from 'utils'
import { startCase } from 'lodash'
import { PlatformIconKey, RoundedPlatformIcon } from 'components/RoundedPlatformIcon/RoundedPlatformIcon'
import cx from 'classnames'

type AccountAvatarProps = {
  account: Pick<ExternalIntegration, 'name' | 'picture'> & { provider: PlatformIconKey }
  size?: 'sm' | 'md' | 'lg'
}

export const AccountAvatar = ({ account, size = 'md' }: AccountAvatarProps) => {
  const { name, picture, provider } = account

  const avatarSizeMap = {
    sm: 16,
    md: 32,
    lg: 60,
  }

  const iconSizeMap = {
    sm: 8,
    md: 16,
    lg: 24,
  }

  return (
    <div className={cx(Styles.avatar, Styles[size])}>
      <Avatar size={avatarSizeMap[size]} label={getInitials(name || startCase(provider))} url={picture} />
      <div className={cx(Styles.icon, Styles[size])}>
        <RoundedPlatformIcon platform={provider} size={iconSizeMap[size]} />
      </div>
    </div>
  )
}
